import HomeIcon from "@mui/icons-material/Home";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  Box,
  Breadcrumbs,
  Chip,
  Link,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import Layout from "../components/layout/Layout.component";
import { useSonho } from "../services/sonhos";
import {
  Lista,
  SlugSonhosRealizadosDetails,
} from "../styles/pages/SlugSonhosRealizadosDetails";

export function SlugSonhosRealizados() {
  const [path, setPath] = useState<string>();
  const { getSonho, selectedData } = useSonho();
  const theme = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
    function getPath() {
      const pathname = window.location.pathname.slice(19);

      setPath(
        decodeURIComponent(
          pathname
            .split("-")
            .map((word) =>
              word
                .split("")
                .map((char, index) => (index === 0 ? char.toUpperCase() : char))
                .join("")
            )
            .join(" ")
        )
      );
    }

    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const id = params.get("id");

    if (id) {
      getSonho(id);
    }

    getPath();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <SlugSonhosRealizadosDetails>
        <div className="content">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: theme.spacing(4),
            }}
          >
            <Breadcrumbs>
              <Link
                underline="hover"
                href="/"
                sx={{ display: "flex", alignItems: "center", color: "black" }}
              >
                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Home
              </Link>
              <Link
                underline="hover"
                href="/sonhos-realizados"
                sx={{ display: "flex", alignItems: "center", color: "black" }}
              >
                Sonhos realizados
              </Link>
              <Typography sx={{ color: "text.primary" }}>Viagens</Typography>
            </Breadcrumbs>
            <Typography variant="h5">{path}</Typography>
            <Box>
              <Chip
                color="primary"
                label={selectedData?.local}
                icon={<LocationOnIcon />}
              />
            </Box>
            <Lista>
              {selectedData?.imagesUrl?.map((item) => (
                <div className="item-list">
                  <img
                    src={item}
                    alt={selectedData.title}
                    className="img-item-list"
                  />
                </div>
              ))}
            </Lista>
          </Box>
        </div>
      </SlugSonhosRealizadosDetails>
    </Layout>
  );
}
